import { render, staticRenderFns } from "./InstituicaoEdit.vue?vue&type=template&id=29e048dc&scoped=true&"
import script from "./InstituicaoEdit.vue?vue&type=script&lang=js&"
export * from "./InstituicaoEdit.vue?vue&type=script&lang=js&"
import style0 from "./InstituicaoEdit.vue?vue&type=style&index=0&id=29e048dc&prod&scoped=true&lang=css&"
import style1 from "./InstituicaoEdit.vue?vue&type=style&index=1&id=29e048dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e048dc",
  null
  
)

export default component.exports